import { ReferralsApi } from "@/api/referrals";
import { Referral } from "@/types";
import { QueryKey } from "@/utils";
import { useInfiniteQuery } from "@tanstack/react-query";

export const useGetReferralInvites = ({
  page,
  referralId,
  perPage,
}: {
  page: number;
  perPage: number;
  referralId?: Referral["id"];
}) => {
  const { data, isPending, fetchNextPage } = useInfiniteQuery({
    queryKey: [QueryKey.REFERRAL_INVITES_USERS, referralId],
    queryFn: ({ pageParam }: { pageParam: number }) => {
      return ReferralsApi.getReferralInvitesUsers({
        perPage,
        page: pageParam,
        referralId: referralId ?? "",
      });
    },
    enabled: !!referralId,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.meta.page + 1;
      return nextPage <= lastPage.meta.totalPages ? nextPage : undefined;
    },
    select: ({ pages }) => {
      return pages.flatMap((data) => data)[page];
    },
  });

  return { invites: data, isReferralInvitesLoading: isPending, fetchNextPage };
};
